import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { isEmpty, has, upperCase } from 'lodash';
import { Link } from 'gatsby';
import {
  InnerBanner,
  BannerDescription,
  BannerHeading,
  BannerP,
  Time,
} from './styles/InnerPageBanner.styled';
import { Container } from './styles/Container.styled';
import ScrollDownButton from './ScrollDownButton';
import { DWTCContext } from '../utils/context';
import { convertMonthToAr } from '../helpers/date-convert';

export default function ImageBanner({ data, id, dir, label }) {
  const { title, image, text, next, prev, jumpToSection, time } = data;
  const { cssClass } = React.useContext(DWTCContext);
  const lang = dir === 'ltr' ? 'en' : 'ar';

  const handleTime = (currTime) => {
    const timeArr = currTime.split(' ');
    const day = timeArr[0].length === 1 ? `0${timeArr[0]}` : timeArr[0];
    timeArr.shift();
    timeArr.unshift(day);
    return timeArr.join(' ');
  };
  
  const isBrowser = typeof window !== 'undefined';
  const [isSustainability, setIsSustainability] = React.useState(false);

  React.useEffect(() => {
    if (isBrowser) {
      setIsSustainability(window.location.pathname === `/${lang}/sustainability/`);
    }
  }, [isBrowser, lang]);
  return (
    <InnerBanner id={id} className={`${cssClass}  ${isSustainability ? 'sustainablity-page' : ''}`}>
      {has(prev, 'url') && (
        <a
          href={prev.url}
          className="slick-arrow slick-prev prev-arrow-adjust"
          aria-label="Previous Content"
          title={prev.url}
        />
      )}
      {isEmpty(image) || (
        <LazyLoadImage
          src={image.url}
          alt={title}
          className={`inner_bnr ${isSustainability ? 'sustainablity-page' : ''}`}
          effect="blur"
          placeholderSrc={image ? `${image.url}?width=50&quality=50` : null}
        />
      )}
      <BannerDescription className="description_banner" dir={dir}>
        <Container className="container_wrapper">
          {!!label && <p className="cTitle">{label}</p>}
          <BannerHeading dir={dir}>{title}</BannerHeading>
          {text ? (
            <BannerP dir={dir}>{dir === 'rtl' ? convertMonthToAr(text) : text}</BannerP>
          ) : null}
          {time ? (
            <Time dir={dir} className="date_time">
              {dir === 'rtl' ? convertMonthToAr(handleTime(time)) : upperCase(handleTime(time))}
            </Time>
          ) : null}
        </Container>
      </BannerDescription>
      {has(next, 'url') && (
        <a
          href={next.url}
          className="slick-arrow slick-next next-arrow-adjust"
          aria-label="Next Content"
          title={next.url}
        />
      )}
      {jumpToSection && (
        <ScrollDownButton position={jumpToSection} />
      )}
    </InnerBanner>
  );
}
